import React,{useState,useEffect} from 'react'
import {toast} from 'react-toastify'
import recallsService from '../../services/recalls.service'
import { useParams,Link } from 'react-router-dom'
import {useForm} from 'react-hook-form'

function RecallEdit() {
    const [recall,setRecall] = useState()
    const {recallId} = useParams()
    const {register,handleSubmit,reset,formState:{errors},} = useForm()
   
    useEffect(()=>{
        getRecallById()
    },[])

    const getRecallById = ()=>{
        recallsService.getRecallsById(recallId)
        .then(res=>{
            setRecall(res.data)
            reset(res.data)
        })
        .catch(err=>{
            console.log(err)
        })
    }

 const onSubmit = (data)=>{
     recallsService.updateRecall(data.id,data)
     .then(res=>{
        toast.success("Recall Updated",{
            position:toast.POSITION.BOTTOM_RIGHT
        })
     })
     .catch(err=>{
        toast.error("Error Updating Recall",{
            position:toast.POSITION.BOTTOM_RIGHT
        })
        console.log(err)
     })
 }
 function processString(str) {
    // Convert the string to lowercase
    let processedStr = str.toLowerCase();
    
    // Replace spaces with underscores
    processedStr = processedStr.replace(/ /g, '_');
    
    // Add timestamp
    const timestamp = new Date().getTime(); // Get current timestamp in milliseconds
    processedStr += '_' + timestamp;
    
    return processedStr;
  }
  
 const handleDownload = (fileurl,id,clinicName)=>{
    recallsService.fileDownload(fileurl)
    .then(response=>{
        const fileName  = processString(clinicName+id)
        // Create a Blob from the response data
    const blob = new Blob([response.data], { type: response.headers['content-type'] });
    // Create a URL for the Blob
    const url = window.URL.createObjectURL(blob);
    // Create an anchor tag
    const link = document.createElement('a');
    link.href = url;
    // Set the file name for download
    link.download = fileName+'.csv'; // Change the filename as needed
    // Programmatically click the anchor tag to trigger download
    link.click();
    // Clean up by revoking the URL
    window.URL.revokeObjectURL(url);
    })
    .catch(err=>{
        console.log(err)
    })
 }
  return (
   <>
     <div className="container container-xxl">
        <div className="pagetitle">
            <h1>Recall Request</h1>
        </div>
        <div className="card mt-2 p-3">
            <div className="card-body">
                {recall && 
                <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                    <div className="col-6">
                        <table className="table table-striped">
                            <tbody>
                                <tr>
                                    <td>Clinic Name:</td>
                                    <td>{recall.clinicName}</td>
                                </tr>
                                <tr>
                                    <td>Title</td>
                                    <td>{recall.title}</td>
                                </tr>
                                <tr>
                                    <td>Notes:</td>
                                    <td>{recall.notes}</td>
                                </tr>
                                
                                <tr>
                                   <td>File Download</td>
                                   <td>
                                    <button className="btn btn-success" onClick={()=>handleDownload(recall.filePath,recall.id,recall.clinicName)}><i className="bi bi-cloud-download"></i> Download </button>
                                   </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <div className="col-6">
                           <div className="form-group">
                                <label htmlFor="" className='form-label'>Status: </label>
                                <select id="status" className='form-select' {...register('status')}>
                                <option value="">Select Status</option>
                                <option value="0">Pending</option>
                                <option value="1">In Process</option>
                                <option value="2">Completed</option>
                                <option value="3">Failed</option>
                                </select>
                           </div>
                           <div className="form-group">
                            <label htmlFor="" className="form-label">Admin Notes:</label>
                                <textarea  cols="30" rows="10" {...register('adminNotes')} className="form-control"></textarea>
                           </div>
                           <button className="btn btn-sm btn-primary mt-2" type="submit"><i className="bi bi-floppy"></i> Save</button>
                    </div>

                </div>
                </form>
                }
            </div>
        </div>
        
   </div>
   </>
  )
}

export default RecallEdit